module.exports = __webpack_public_path__ + "assets/d49df6c4cd8d94c35861723ed7544829.png";